import { Container, IconButton, makeStyles, Tooltip, Typography } from '@material-ui/core';

import CheckboxUI, { CheckboxProps } from './checkbox';
import Date from './date';
import DatetimeSelect from './datetimeSelect';
import FloatInput from './floatInput';
import InfoIcon from '@material-ui/icons/Info';
import IntegerInput from './integerInput';
import MultiSelect, { MultiSelectProps } from './multiSelect';
import SelectMenu, { SelectMenuProps } from './select';
import TextInput from './textInput';
import TimeSelect from './timeSelect';

export interface Constraint {
  key: string;
  value: string;
}

export type DefaultCommandProps = {
  constraints?: Constraint[];
  description?: string;
  friendly?: string;
  label: string;
  onChange: (id: string, value: string | number | boolean | string[]) => void;
  setInputsError: (value: boolean) => void;
  value: string | number | boolean | string[];
  name: string;
};

export type CommandUIPropsData = CheckboxProps | SelectMenuProps | MultiSelectProps;

type CommandUIProps = {
  dataType: string;
  props: CheckboxProps | SelectMenuProps | MultiSelectProps;
};

interface StylesProps {
  type: string;
}

const useStyles = makeStyles(() => ({
  container: {
    alignItems: (props: StylesProps) => (props.type === 'bool' ? 'center' : 'baseline'),
    display: 'flex',
    height: (props: StylesProps) => (props.type === 'bool' ? '32px' : 'unset'),
  },
  label: {
    display: 'flex',
    marginRight: '15px',
    padding: 0,
    whiteSpace: 'nowrap',
  },
  labelTitle: {
    marginRight: '5px',
    width: '150px',
  },
}));

const CommandUI: React.FC<CommandUIProps> = ({ dataType, props }) => {
  const classes = useStyles({ type: dataType });

  const getUI = () => {
    switch (dataType.toLocaleLowerCase()) {
      case 'bool':
        return <CheckboxUI {...(props as CheckboxProps)} />;
      case 'int':
        return <IntegerInput {...(props as DefaultCommandProps)} />;
      case 'float':
        return <FloatInput {...(props as DefaultCommandProps)} />;
      case 'enum':
        return <SelectMenu {...(props as SelectMenuProps)} />;
      case 'bitmap':
        return <MultiSelect {...(props as MultiSelectProps)} />;
      case 'date':
        return <Date {...(props as DefaultCommandProps)} />;
      case 'time':
        return <TimeSelect {...(props as DefaultCommandProps)} />;
      case 'datetime':
        return <DatetimeSelect {...(props as DefaultCommandProps)} />;
      default:
        return <TextInput {...(props as DefaultCommandProps)} />;
    }
  };

  return (
    <Container className={classes.container}>
      <div className={classes.label}>
        <Typography className={classes.labelTitle}>{props.friendly || props.name}</Typography>
        {props.description && (
          <Tooltip title={props.description} placement="bottom">
            <IconButton aria-label={props.description} style={{ width: 24, height: 24 }}>
              <InfoIcon fontSize="small" />
            </IconButton>
          </Tooltip>
        )}
      </div>
      <>{getUI()}</>
    </Container>
  );
};

export default CommandUI;
